import { IGroup } from '../resources/istatement/group';
import { IAgent } from '../resources/istatement/agent';
import { Agent, AgentParams } from './agent';

export interface GroupParams extends AgentParams {
	members?: (Agent | IAgent)[];
}

export class Group extends Agent {
	objectType = 'Group';
	members: Agent[];

	constructor(cfg?: GroupParams) {
		super(cfg);
		this.members = [];

		this.init(cfg);
	}

	init(cfg: GroupParams = {}): void {
		if (cfg.members) {
			this.members = cfg.members.map((member: Agent | IAgent) => {
				if (member instanceof Agent) {
					return member;
				}
				return new Agent(member);
			});
		}

		super.init(cfg);
	}

	toString(): string {
		let result = super.toString();
		if (result !== `${this.objectType}: unidentified`) {
			result = `${this.objectType}: ${result}`;
		}

		return result;
	}

	/**
        @method asVersion
        @param {String} [version] Version to return (defaults to newest supported)
        */
	asVersion(version: string = '1.0.3'): IGroup {
		const result = super.asVersion(version) as IGroup;

		if (this.members.length > 0) {
			result.members = this.members.map((member) => member.asVersion(version));
		}

		return result;
	}
	static fromJSON(groupJSON: string): Group {
		const _group = JSON.parse(groupJSON);

		return new Group(_group);
	}
}
